export default __webpack_public_path__ + "static/media/Netflix_LoadTime.cc57505c.gif";